<template>
  <div class="ban">
    <el-carousel
      :interval="40000"
      arrow="always"
      height="400px"
      class="swipper"
    >
      <el-carousel-item v-for="(item, index) in banners" :key="index">
        <div class="ban-banner">
          <img :src="item.bannerPath" @click="bannerClick(item)" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { homeBanner } from "@/api/home";
export default {
  components: {},
  data() {
    return {
      banners: [],
    };
  },
  computed: {
    ...mapGetters(["token", "userBaseInfo"]),
  },
  created() {
    this.getBanners();
  },
  methods: {
    async getBanners() {
      const res = await this.$axios.get(homeBanner, { bannerType: "1" });
      this.banners = res;
    },
    bannerClick({ bannerLink }) {
      if (bannerLink) {
        window.open(bannerLink);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.ban {
  background: $home-bg;
  &-inner {
    width: $max-width;
    margin: 0 auto;
  }
  &-banner {
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
